import { formatDate } from '@fullcalendar/core'

const classDates = [
	'08-30',
	'09-01',
	'09-03',
	'09-06',
	'09-08',
	'09-10',
	'09-13',
	'09-15',
	'09-17',
	'09-22',
	'09-24',
	'09-27',
	'09-29',
	'10-01',
	'10-04',
	'10-06',
	'10-08',
	'10-13',
	'10-15',
	'10-18',
	'10-20',
	'10-22',
	'10-25',
	'10-27',
	'10-29',
	'11-01',
	'11-03',
	'11-05',
	'11-08',
	'11-10',
	'11-15',
	'11-17',
	'11-19',
	'11-22',
	'11-29',
	'12-01',
	'12-03',
	'12-06',
	'12-08',
	'12-10',
].map(x=>'2021-'+x);

const examPeriod = [
	'12-13',
	'12-14',
	'12-15',
	'12-16',
	'12-17'
].map(x=>'2021-'+x);

const breakDays = [
	'10-11',
	'10-12',
	'11-24',
	'11-25',
	'11-26'
].map(x=>'2021-'+x);

const problemSetsAssigned = [
	'10-01',
	'12-03'
].map(x=>'2021-'+x);

const problemSetsDue = [
	'10-08',
	'12-13'
].map(x=>'2021-'+x+'T14:00');

const dialoguesDue = [
	'11-01',
	'12-08'
].map(x=>'2021-'+x+'T14:00');

const promptsDue = [
	'09-10',
	'10-01',
	'10-20',
	'11-15',
	'12-03'
].map(x=>'2021-'+x+'T14:00');

const classesCancelled = [
	'09-20',
	'11-12'
].map(x=>'2021-'+x);

const linkto = (x,y) => `<a href="${y}"><i>${x}</i></a>`

const modules = [
	{title: "Introduction",
	section: 0,
	readings: [	
		[], 
		[]
		],
	slides: [
		,
		`ai-01-arguments`
	]
	},
	{title: "What Is AI?",
	extendedtitle: "Its Past, Present, and Future",
	section: 1,
	readings: [
		[	`Daniel Dennett, ${linkto(`Can Machines Think?`,"/assets/DennettCMT.pdf")} <i>(the postscripts are optional)</i>`, `<i>Optional</i>: Tom Scott, ${linkto("I'm Not A Robot video", "https://www.youtube.com/watch?v=o1zNIm8GVPY")}`],
		[	`Margaret Boden, chapter 1`],
		[	`Margaret Boden, chapter 2`]
		],
	slides: [
		`ai-02-turing-test`,
		`ai-03-what-is-ai`,
		false
		]
	},
	{title: "How AI Works", 
	extendedtitle: "Models and Paradigms",
	section: 1,
	readings: [
		[`Garry Kasparov, ${linkto("The Chess Master and the Computer", "http://web.mit.edu/6.034/wwwbob/kasparov-article.pdf")}`,
			`<i>Optional</i>: ${linkto("selections from Artificial Intelligence: A Modern Approach", "/assets/RNSelections.pdf")} <p class="readingDescription">You might find the optional reading quite difficult, but I want to give you the opportunity to try stumbling through an AI textbook.  I will explain the basic concepts in class.  Note that I've blocked out passages not relevant for us.</p>`], //Russell appendix A would be good for chess-playing computers.
		[`Stephen Pinker, ${linkto("How the Mind Works","/assets/PinkerHTMW.pdf")}, pages 98-111 <p class="readingDescription">(we will read the rest of the pdf next week)</p>`, `<i>Optional</i>: ${linkto(`How the Computer Beat the Go Player`, "https://alleninstitute.org/media/filer_public/d5/eb/d5eb3687-400b-4ff8-bacd-30be51bfb026/2016_07_howcomputerbeatgoplayer.pdf")}`, `<i>Optional</i>: Garry Kasparov, ${linkto("Chess, a Drosophila of Reasoning","https://www.science.org/doi/full/10.1126/science.aaw2221")}`],
		[`Margaret Boden, chapter 4`], // in the future, it would probably be better to swap Boden and Pinker.  Maybe consider the Russell, Appendix D
		[`Ted Chiang, ${linkto("ChatGPT is a Blurry JPEG of the Web", "https://www.newyorker.com/tech/annals-of-technology/chatgpt-is-a-blurry-jpeg-of-the-web")}`, `Nick Walton, ${linkto("article on AI Dungeon: Dragon Update", "https://aidungeon.medium.com/ai-dungeon-dragon-model-upgrade-7e8ea579abfe")}`, `Play around with ${linkto("AI Dungeon", "https://play.aidungeon.io/main/landing")}`, `<i>Optional</i>: Jay Alammar, ${linkto("How GPT-3 Works", "http://jalammar.github.io/how-gpt3-works-visualizations-animations/")}`, `<i>Optional</i>: ${linkto(`Philosophers on GPT-3`, "https://dailynous.com/2020/07/30/philosophers-gpt-3/")}`, `<i>Optional</i>: ${linkto(`Ben Levinstein, A Conceptual Guide to Transformers (Substack posts)`, "https://benlevinstein.substack.com/")}`]
		], // In the future, don't include Pinker (weird account of auto-associators, just use pictures in class.)  Instead, chapter 3 of Russell, maybe appendix D.
	slides: [
		`ai-04-GOFAI`,
		`ai-05-NNs`,
		`ai-06-NN-data`,
		`ai-07-successes`
		]
		// https://mind.ilstu.edu/curriculum/connectionism_intro/index.html is a good intro.  Should have used it.
	},
	{title: "Problems",
	extendedtitle: `Why Computer Minds Might Not Be Possible`,
	section: 1,
	readings: [
		[`Steven Pinker, ${linkto("How the Mind Works","/assets/PinkerHTMW.pdf")}, pages 111-131`, `<i>Optional</i>: Tom Scott, ${linkto(`video on the Winograd Schema`, "https://www.youtube.com/watch?v=m3vIEKWrP9Q")}`, `<i>Optional</i>: Melanie Mitchell,  ${linkto("What Does It Mean For AI to Understand?","https://www.quantamagazine.org/what-does-it-mean-for-ai-to-understand-20211216/")}`],  // Start at 114 next time
		[`Margaret Boden, pages 43 and 44`, `Gary Marcus and Ernest Davis, ${linkto("Rebooting AI, pages 55-94", "/assets/MarcusDavisRI34.pdf")} <p class="readingDescription">You can optionally read the earlier pages of Chapter 3 for another take on how neural networks work.</p>`, `<i>Optional</i>: Browse ${linkto("AI Weirdness", "https://www.aiweirdness.com/")}`, `<i>Optional</i>: ${linkto("Magic AI", "https://www.theverge.com/2017/4/12/15271874/ai-adversarial-images-fooling-attacks-artificial-intelligence")}`],
		[`MOVIE: ${linkto("Ex Machina","https://clarkson.kanopy.com/video/ex-machina-0")} <p class="readingDescription">The Clarkson library has purchased a license for the movie.  You will be able to stream it at the above link if you log in with your Clarkson credentials.`, `<i>Optional</i>: Susan Blackmore, ${linkto(`"What Is It Like?"`, `assets/BlackmoreWIIL.pdf`)}`, `<i>Optional</i>: Daniel Dennett, ${linkto("What RoboMary Knows", "https://ase.tufts.edu/cogstud/dennett/papers/RoboMaryfinal.htm")}`],
		[`Susan Schneider, chapters 2 and 4`, `<i>Optional</i>: Susan Schneider, chapter 3`, `<i>Optional</i>: Margaret Boden, chapter 6`],
		[`Douglas Hofstadter, ${linkto("The Shallowness of Google Translate", "https://www.theatlantic.com/technology/archive/2018/01/the-shallowness-of-google-translate/551570/")}`,`John Searle, ${linkto("Can Computers Think?", "assets/SearleCCT.pdf")}`]
		], // this Hofstadter article should come before the consciousness ones, I think.  It's also pretty similar to the Marcus and Davies.  Maybe make it optional.
	slides: [
		`ai-08-associationism`,
		`ai-09-common-sense`,
		`ai-10-consciousness`,
		`ai-11-consciousness2`,
		`ai-12-searle`
		]
	},
	{title: "Art & Emotion",
	extendedtitle: "The Essentially Human?",
	section: 1,
	readings: [
		[`Margaret Boden, chapter 3`, `Janelle Shane, ${linkto("My Favorite Nonexistent Painter", "https://www.aiweirdness.com/my-favorite-nonexistent-painter/")}`, `<i>Optional</i>: Harold Cohen, ${linkto("The Further Exploits of AARON, Painter", "https://web.archive.org/web/20060107184824/http://crca.ucsd.edu/~hcohen/cohenpdf/furtherexploits.pdf")}`],
		[`Kate Crawford, chapter 5`, `<i>Optional</i>: Rana el Kaliouby, ${linkto(`<i>Girl Decoded</i>, chapter 25`,"/assets/elKalioubyGD25.pdf")}`],
		[`Kate Darling, ${linkto("<i>The New Breed</i>, chapter 4", "/assets/DarlingNB4.pdf")}`]
		],
	slides: [
		`ai-13-creativity`,
		`ai-14-emotion-recognition`,
		`ai-15-emotion`
		]
	},
	{title: "Human Minds",
	extendedtitle: "Are We All Computers?",
	section: 1,
	readings: [
		[`Terry Bisson, ${linkto("They're Made Out of Meat","https://www.mit.edu/people/dpolicar/writing/prose/text/thinkingMeat.html")}`, `John G. Daugman, ${linkto("Brain Metaphor and Brain Theory","/assets/DaugmanBMBT.pdf")}`, `<i>Optional</i>: Rodney Brooks, ${linkto("Cognition Without Computation","https://spectrum.ieee.org/cognition-without-computation")}`], 
		[`Churchland, Koch, and Sejnowski, ${linkto("What Is Computational Neuroscience?", "/assets/ChurchlandWICN.pdf")}`, `<i>Optional</i>: Quinlan and Dyson, ${linkto("reading on Marr's levels", "/assets/QuinlanDyson.pdf")}`, `<i>Optional</i>: Ian Ravenscroft, ${linkto("The Computational Theory of Mind", "/assets/RavenscroftCTM.pdf")}`], // `<i>Optional</i>: Catherine Stinton, "From Implausible Artificial Neurons..."`, `<i>Optional</i>: Gualtiero Piccinini, "Computationalism in the Philosophy of Mind"`
		// in the future, I think I should block out hard parts of the Churchland and move the stuff on Marr's levels way earlier in the class, when talking about physical implementations.  There should just be a class on implementation.
		// theres' stuff on the mind/body problem and "patternism" in the next section that should be moved here.
		[`David Chalmers and Andy Clark, ${linkto("The Extended Mind", "https://www.nyu.edu/gsas/dept/philo/courses/concepts/clark.html")}`]
		],
	slides: [
		`ai-16-metaphor`,
		`ai-17-what-are-computers`,
		`ai-18-extended-mind`
		]
	},
	{title: "Transhumanism",
	section: 1,
	readings: [
		[`Susan Schneider, chapters 5 and 6`, `<i>Optional</i>: Daniel Dennett, ${linkto("Where Am I?", "https://www.lehigh.edu/~mhb0/Dennett-WhereAmI.pdf")}`],
		[`Susan Schneider, chapter 8 and Transhumanist Manifesto (in back of book)`], // Check out Keith Wiley's Metaphysics of Mind Uploading Book!  It's cheap.
		// these last couple of classes were a bit of a mess, largely because Schneider's book has such a bizarre structure.  I think maybe two or three  classes:
		// one on functionalism, patternism, and mind/body problem (but maybe include more of this in the previous section)
		// one on implants and transhumanism
		// one on mind uploading and the reduplication problem
		[`Nick Bostrom, ${linkto("The Simulation Argument","/assets/BostromSA.pdf")}`, `<i>Optional</i>: ${linkto("What Are the Odds We Are Living in a Computer Simulation?","https://www.newyorker.com/books/joshua-rothman/what-are-the-odds-we-are-living-in-a-computer-simulation")}`, `<i>Optional</i>: David Chalmers, ${linkto("The Matrix as Metaphysics", "/assets/ChalmersMM.pdf")}`]
		],
	slides: [
		`ai-19-self-duplication`,
		`ai-20-transhumanism`,
		`ai-21-simulation`
		]
	},
	{title: "Machine Bias",
	extendedtitle: "Opaque Algorithms and Dirty Data",
	section: 2,
	readings: [
		[`Kate Crawford, chapter 3`, `<i>Optional Movie</i>: Coded Bias (available on Netflix)`, `<i>Optional</i>: ProPublica authors, ${linkto("Machine Bias", "https://www.propublica.org/article/machine-bias-risk-assessments-in-criminal-sentencing")}`],
		[`Kate Crawford, chapter 4`],
		[`Safiya Umoja Noble, chapter 1`, `<i>Optional</i>: ${linkto("Feminist.AI", "https://www.feminist.ai/")}, ${linkto("Algorithms of Oppression Book Club and Study Group", "https://www.feminist.ai/aoo-book-club")}`],
		[`Safiya Umoja Noble, chapter 2`, `<i>Optional</i>: chapter 5 and conclusion`, `<i>Optional</i>: Timnit Gebru, ${linkto("Race and Gender", "/assets/GebruRG.pdf")}`],
		[`The Royal Society Policy Briefing, ${linkto(`"Explainable AI: The Basics"`,"https://royalsociety.org/-/media/policy/projects/explainable-ai/AI-and-interpretability-policy-briefing.pdf")}`, `<i>Optional</i>: Daly, Devitt, and Mann, ${linkto("AI Ethics Needs Good Data", "https://arxiv.org/pdf/2102.07333")}`, `<i>Optional</i>: ${linkto("The Dark Secret at the Heart of AI","https://getpocket.com/explore/item/the-dark-secret-at-the-heart-of-ai")}`],
		], // the Noble talks were brutally bad on my part.  Condense those first four classes for sure.
	slides: [
		`ai-22-data`,
		`ai-23-categorization`,
		`ai-24-oppression`,
		`ai-25-search`,
		`ai-26-xai`
		]
	},
	{title: "Responsibility",
	extendedtitle: "Trusting AI in Critical Infrastructure",
	section: 2,
		readings: [
		[`Kate Darling, ${linkto("The New Breed, chapter 3","/assets/DarlingNB3.pdf")}`, `<i>Optional</i>: Marcus and Davis, ${linkto("Rebooting AI, chapter 8", "/assets/MarcusDavisRI8.pdf")}`, `<i>Optional<i>: Amodei et al., ${linkto("Concrete Problems in AI Safety","/assets/AmodeiCPAS.pdf")}`],
		[`Frances Kamm, ${linkto("The Use and Abuse of the Trolley Problem", "/assets/KammUATP.pdf")}`, `<i>Optional</i>: ${linkto("The Moral Machine", "https://www.moralmachine.net/")}`] // assign selections of the Kamm next time.  Sections 2.1, 2.2, 2.5, 2.6.
		],
	slides: [
		`ai-27-risks`,
		`ai-28-cars`
		]
	},
	{title: "Labor",
	extendedtitle: "Are We Better Off If Robots Do Our Jobs?",
	section: 2,
		readings: [
		[`Kate Crawford, chapters 1 and 2`, `<i>Optional</i>: ${linkto("Kate Crawford video, Anatomy of AI", "https://www.youtube.com/watch?v=uM7gqPnmDDc")}`], // not sure this is a great class.
		[`John Danaher, ${linkto("Automation and Utopia, chapter 2", "/assets/DanaharAU2.pdf")}`, `<i>Optional</i>: video, ${linkto("Humans Need Not Apply","https://www.youtube.com/watch?v=7Pq-S557XQU")}`],
		[`John Danaher, ${linkto("Automation and Utopia, chapter 4", "/assets/DanaharAU4.pdf")}`]
		],
	slides: [
		`ai-29-hidden-costs`,
		`ai-30-automation`,
		`ai-31-meaning`
		]
	},
	{title: "Power",
	extendedtitle: "The State, Privacy, Automated Warfare",
	section: 2,
		readings: [
		[`Crawford, chapter 6 and conclusion`],
		[`Asaro, ${linkto("Autonomous Weapons and the Ethics of Artificial Intelligence", "/assets/AsaroAWEAI.pdf")}`, `<i>Optional<i>: ${linkto("AI Is Making it Easier to Kill (You).  Here's How.", "https://www.youtube.com/watch?v=GFD_Cgr2zho")}`, `<i>Optional<i>: ${linkto("Slaughterbots", "https://www.youtube.com/watch?v=9CO6M2HsoIA")}`]
		],
		// https://www.evilaicartoons.com/archive/threats-of-evil-ai-the-threat-to-peace
		// https://www.evilaicartoons.com/archive/features-of-evil-ai-autonomy
		// makes more sense in the future to swap the sections on Power and Automation.  Automation leads pretty naturally to singularity.
	slides: [
		`ai-32-privacy`,
		`ai-33-war`
		]
	},
	// for missing class, maybe do something on human relationships being overtaken by AI?  Seals, sexbots, children, etc. (Maybe move this to previous section, call it "human replacement" or something.  Jobs, sex, relationships, education.  Move the one on creation of AI and resources somewhere else. To power section, perhaps.)
	// https://www.evilaicartoons.com/archive/threats-of-evil-ai-the-threat-to-individual-development
	// https://www.evilaicartoons.com/archive/threats-of-evil-ai-the-threat-to-human-relationships
	{title: "Singularity",
	extendedtitle: "Could AI Threaten Human Existence Itself?",
	section: 2,
		readings: [
		[`Margaret Boden, chapter 7`, `Ted Chiang, ${linkto("Why Computers Won't Make Themselves Smarter", "https://www.newyorker.com/culture/annals-of-inquiry/why-computers-wont-make-themselves-smarter")}`, `<i>Optional</i>: Susan Schneider, chapter 7`],
		[`Raffi Khatchadourian, ${linkto("The Doomsday Invention", "https://www.newyorker.com/magazine/2015/11/23/doomsday-invention-artificial-intelligence-nick-bostrom")}`, `Play some of ${linkto("Universal Paperclips", "https://www.decisionproblem.com/paperclips/")}`, `<i>Optional</i>: Taylor, Yudkowsky, LaVictoire, and Critch, ${linkto("Alignment for Advanced Machine Learning Systems", "/assets/TaylorAAMLS.pdf")}`, `<i>Optional</i>: Explore ${linkto("Robert Miles' videos on AI safety", "https://www.youtube.com/c/RobertMilesAI/videos")}`]
		// 4 kinds of evil: https://www.evilaicartoons.com/archive/aims-of-evil-ai-the-four-motives-of-evil
		],
	slides: [
		`ai-34-singularity`,
		`ai-35-singularity2`
		]
	},	
	{title: "AI Rights",
	extendedtitle: "When Do Robots Become People?",
	section: 2,
		readings: [
		[`Harry Shevlin, ${linkto("How Could We Know When a Robot was a Moral Patient?", "/assets/ShevlinHCWK.pdf")}`, `<i>Optional</i>: Kate Darling, ${linkto("The New Breed, chapter 10","/assets/DarlingNB10.pdf")}`, `<i>Optional</i>: The Outer Limits (1963), ${linkto("I, Robot episode", "https://pluto.tv/en/on-demand/series/the-outer-limits-1963/season/2/episode/i-robot-1964-2-9")}`], // Adam Robot from I, Robot episode of Outer Limits might be fun here.
		[`Eric Schwitzgebel and Mara Garza, ${linkto("Designing AI with Rights, Consciousness, Self-Respect, and Freedom","/assets/SchwitzgebelDAI.pdf")}`, `<i>Optional</i>: Eric Schwitzgebel and Mara Garza, ${linkto("A Defense of the Rights of Artificial Intelligences","http://www.faculty.ucr.edu/~eschwitz/SchwitzPapers/AIRights-150915.pdf")}`,`<i>Optional</i>: Daniel Estrada, ${linkto("Robot Rights. Cheap Yo!","https://www.youtube.com/watch?v=TUMIxBnVsGc")}`], // the video should probably go with the Darling reading.  I think I need to reorient this week.  Maybe one more class.  Maybe one on Shevlin and early Schwitz paper, then Darling and Estrada, then Schwitz 2, then Suber?  (Moral difference class, then social contract class, then constraints on building class, then Suber class.)  Hard to say.  I like the content but the order here is all wrong.
		[`Peter Suber, ${linkto(`"Saving Machines From Themselves"`, "http://legacy.earlham.edu/~peters/writing/selfmod.htm")}`],
		],
	slides: [
		`ai-36-persons`,
		`ai-37-robot-rights`,
		`ai-38-self-modification`
		]
	},
];


const buildModuleDates = () => {
	let currClass = 0;
	const moduleDates = [];
	for (let i=0; i<modules.length; i++) {
		for (let j=0; j<modules[i].readings.length; j++) {
			moduleDates.push({
				title: modules[i].title,
				start: classDates[currClass],
				readings: modules[i].readings[j],
				modulelength: modules[i].readings.length,
				firstinmodule: !j,
				slides: modules[i].slides ? modules[i].slides[j] : null					// use optional chaining slides: modules[i]?.slides[j]
			})
			currClass++;
		}
	}
	return moduleDates;
}


const moduleEvents = buildModuleDates();
const dialogueEvents = dialoguesDue.map((x,i)=>({title: `Essay ${i+1} due`, start: x	}))
const promptEvents = promptsDue.map((x,i)=>({title: `Prompt Response ${i+1} due`, start: x	}))
const problemSetsAssignedEvents = problemSetsAssigned.map((x,i)=>({title:`Problem Set ${i+1} Available`, start: x}))
const problemSetsDueEvents = problemSetsDue.map((x,i)=>({title:`Problem Set ${i+1} Due`, start: x}))
const breakDayEvents = breakDays.map((x,i)=>({title:"Break Day", start: x}));
const examEvents = examPeriod.map((x,i)=>({title:"Exams", start: x}));
const cancelledEvents = classesCancelled.map((x,i)=>({title:"Class cancelled", start: x}));

if (moduleEvents.length !== classDates.length) {
	console.log(`Events: ${moduleEvents.length}.  Class dates: ${classDates.length}`)
}

export { promptEvents, classDates, moduleEvents, breakDayEvents, problemSetsAssignedEvents, problemSetsDueEvents, dialogueEvents, examEvents, cancelledEvents };